// import {Modal} from "react-bootstrap";
import React, {Fragment, useState} from "react";
import Container from "react-bootstrap/Container";
import {Card} from "react-bootstrap"
import {
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Button, ButtonGroup, Input,
    Nav, NavItem, NavLink,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import {ConfirmDeleteModal} from "./index";
import ReportItem from "./ReportItem";
import AddReport from "./AddReport";

const ReportModal = ({onHide, show, deleteActiveReport, data, activeReportID, setModalShow, modalShow, Save, labelsSplited}) => {
    const [itemDisplay, setItemDisplay] = useState(1)
    return (
        <Modal 
               isOpen={show}
            //    aria-labelledby="contained-modal-title-vcenter"
            //    centered
            //    style={{opacity: 1}}
               toggle={e => onHide(false)}
               size='lg'
        >
            <ModalHeader>
                {/* <Modal.Title id="contained-modal-title-vcenter"> */}
                    <Nav id="tabs" role="tablist" tabs>
                        <NavItem>
                            <NavLink aria-expanded={itemDisplay === 1} data-toggle="tab" role="tab"
                                     style={{cursor: 'pointer'}}
                                     className={itemDisplay === 1 ? "active arrowWsk wskaznikiPanel" : "arrowWsk"} onClick={() => {
                                setItemDisplay(1)
                            }}>
                                Rachunek zysków i strat
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink aria-expanded={itemDisplay === 2} data-toggle="tab" role="tab"
                                     style={{cursor: 'pointer'}}
                                     className={itemDisplay === 2 ? "active arrowWsk wskaznikiPanel" : "arrowWsk"} onClick={() => {
                                setItemDisplay(2)
                            }}>
                                Bilans
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink aria-expanded={itemDisplay === 3} data-toggle="tab" role="tab"
                                     style={{cursor: 'pointer', maxWidth: "32vw"}}
                                     className={itemDisplay === 3 ? "active arrowWsk wskaznikiPanel" : "arrowWsk"} onClick={() => {
                                setItemDisplay(3)
                            }}>
                                Rachunek przepływów pieniężnych
                            </NavLink>
                        </NavItem>
                    </Nav>
                {/* </Modal.Title> */}
            </ModalHeader>
            {itemDisplay === 1 && labelsSplited && data &&
                <ReportItem labels={labelsSplited.rzis} data={data.rachunek_zyskow} name={"rachunek_zyskow"} Save={Save} onHide={onHide}/>}
            {itemDisplay === 2 && labelsSplited && data &&
                <ReportItem labels={labelsSplited.bilans} data={data.bilans} name={"bilans"} Save={Save} onHide={onHide}/>}
            {itemDisplay === 3 && labelsSplited && data && 
                <ReportItem labels={labelsSplited.cashflow} data={data.rachunek_przeplywu} name={"rachunek_przeplywu"}  Save={Save}/>}
        </Modal>
    );
};

export default ReportModal

